import * as tslib_1 from "tslib";
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { lazyForwardMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
export default action('forwardItem')(function forwardItem(itemId, actionSource, instrumentationContexts) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var restrictionToConfirm;
        return tslib_1.__generator(this, function (_a) {
            restrictionToConfirm = { ForwardAllowed: true };
            if (confirmItemActionAllowed(itemId.Id, restrictionToConfirm, format(strings.irm_actionNotAllowedOnThisItem, strings.itemHeaderForward))) {
                lazyForwardMessage.importAndExecute(itemId, actionSource, instrumentationContexts);
                mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
            }
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=forwardItem.js.map